import { Button, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CustomContext } from '../page';
import { ACTIONS, STAGE_ACTIONS } from '../_utils/definitions-config';

export function ActionCellRenderer(params) {
  const [anchor, setAnchor] = useState(null);
  const { setSelectedAction, setSelectedBooking } = useContext(CustomContext);
  const history = useHistory();

  const handleClick = (action) => {
    if (action === ACTIONS.SESSION_DETAILS)
      history.push(`/manage-bookings/session-details/${params.data.id}`);
    else if (action === ACTIONS.REVIEW_SESSION)
      history.push({
        pathname: `/manage-bookings/session-review/${params.data.id}`,
      });
    else {
      setSelectedAction(action);
      setSelectedBooking(params.data);
    }
    setAnchor(null);
  };

  let actions = STAGE_ACTIONS[params.data.stage] || [];
  if (params.data.status === 'defaulted')
    actions = [ACTIONS.REACTIVATE_BOOKING];
  return (
    <>
      <Button
        onClick={(e) => setAnchor(e.currentTarget)}
        aria-controls='actions-menu'
        aria-haspopup='true'
        className='opacity-60'
      >
        <MoreVert />
      </Button>
      <Menu
        id='simple-menu'
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        keepMounted
      >
        {actions.map((action) => (
          <MenuItem
            onClick={() => handleClick(action)}
            value={action}
            key={action}
          >
            {action}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
